import { GiphyFetch } from '@giphy/js-fetch-api';
import memoizeOne from 'memoize-one';

export const getGiphyApi = memoizeOne(
  () => new GiphyFetch('DOl4PIGDk4srrYJzMgI0KiTrL2qM2IG4'),
);
